import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './services/auth.service';
import { SalesService } from './services/sales.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private readonly saleService: SalesService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const navigation = this.router.getCurrentNavigation();
    const hasProfile = this.authService.hasUserProfile();
    const additional = navigation.extras.state as { encryptedSaleMemberAccessId: string, saleId: number };
    if (!this.authService.isAuthenticated()) {      
      if (additional) {
        this.router.navigate(['/'], {
          state: { encryptedSaleMemberAccessId: additional.encryptedSaleMemberAccessId, saleId: additional.saleId }
        }); // go to lnading page if not authenticated
      } else {
        this.router.navigate(['/']);        
      }
      return false;
    }
   
    
    return true;
  }
}
